import { User } from '../models/user';

export class UpdateUserStatus {
    static readonly type = '[User] UpdateUserStatus';

    constructor(public payload: User) {}
}
